import { Injectable } from '@angular/core';
import { CredentialActions, ICredential } from 'src/modules/credentials/interfaces/credential.interface';
import { IUser } from 'src/modules/authentication/interfaces/user.interface';

@Injectable({
  providedIn: 'root',
})
export class SharedDataService {

  selectedCredential?: ICredential;
  selectedFilesToUpload?: File[];
  uploadingAction?: CredentialActions;
  employeeCredentialIdToUpdate?: number;
  currentUser?: IUser; // Current user data shared across components

  constructor() {}
}
